import React from 'react';
import { Img } from 'react-image';
import { gridTemplates } from './task-utility';

const AssessmentResponse = ({className, type, options, selected, onSelect}) => {
	const gridType = type.replace(/\s+/g, '');
	const { respSize } = gridTemplates[gridType];
	
	const style = {
		width: `${respSize.width}px`,
		height: `${respSize.height}px`
	};
	
	return (
		<div className={'assessment-response' + (className ? ' ' + className : '')}>
			{options.map((option, i) => {
				const { value, image, text, isCorrect } = option;
				const selectedClass = selected.includes(value) ? ' selected' : '';
				const correctClass = isCorrect ? ' correct' : '';
				const response = text ? text : value;

				const imgProps = {
					className: 'response-image',
					src: image,
					alt: response,
					style,
					...respSize
				}

				return (
					<button className={`response-option${selectedClass}${correctClass}`} onClick={() => onSelect(value)} key={i}>
						<Img {...imgProps} loader={
							<img {...imgProps} loading="lazy" />
						} />
						<div className="response-text">{response}</div>
					</button>
				);
			})}
		</div>
	);
}

export default AssessmentResponse;
